var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-1",class:{ margin: _vm.$vuetify.breakpoint.mdAndUp },attrs:{"fab":"","fixed":_vm.$vuetify.breakpoint.smAndDown,"absolute":_vm.$vuetify.breakpoint.mdAndUp,"top":"","right":"","elevation":"12","small":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('v-icon',[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }